module.exports = __webpack_public_path__ + "img/icon_no_history.b50d29d5.svg";